import { atom } from 'recoil'

interface DevicesType {
  deviceId: string
  label: string
}

interface videoDevicesType extends DevicesType {}
interface audioInputDevicesType extends DevicesType {}
interface audioOutputDevicesType extends DevicesType {}

export interface devicesDataType {
  videoDevices: videoDevicesType[]
  audioInputDevices: audioInputDevicesType[]
  audioOutputDevices: audioOutputDevicesType[]
}

// 设备检测弹框
export const deviceShowState = atom({
  key: 'deviceShow',
  default: false
})

// 进入教室，未检测，询问弹框
export const deviceFailShowState = atom({
  key: 'deviceFailShow',
  default: false
})

export const devicesState = atom({
  key: 'devices',
  default: []
})

// 设备数据集
export const devicesDataState = atom<devicesDataType>({
  key: 'devicesData',
  default: {
    // 视频
    videoDevices: [],
    // 麦克风
    audioInputDevices: [],
    // 扬声器
    audioOutputDevices: []
  }
})

// 网络平均质量的文案
export const resultState = atom<string>({
  key: 'result',
  default: ''
})

// 网络测试的数量
export const netNumState = atom<number>({
  key: 'netNum',
  default: 0
})

// 网络测试中最低质量
export const netLowestState = atom<number>({
  key: 'netLowest',
  default: 0
})

// 网络测试中最高质量
export const netHighestState = atom<number>({
  key: 'netHighest',
  default: 0
})

// 设备检测 ：点击教室，成功之后 需要教室信息
export const roomInfoState = atom({
  key: 'roomInfo',
  default: {}
})
